module.exports = __webpack_public_path__ + "static/img/noAct.8bc705ee.png";